import Vue from 'vue'
import VueRouter from 'vue-router';

import {routes} from "./routes";
import store from "../store";

Vue.use(VueRouter)



const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
    
    //avoid an integradora user or employee enter to other route if its has an temporary password
    if(store.state && store.state.userData){
      if("employee_site" in store.state.userData.role.permissions){
        if(store.state.userData.role.permissions.employee_site.show){
            if(store.state.userData.has_temp_password){
              if(to.name !== 'ResetPasswordEmployee'){
                return next('/m/reset-password');
              }
            }
        }
      }
      if("integradora_user" in store.state.userData.role.permissions){
        if(store.state.userData.role.permissions.integradora_user.show){
            if(store.state.userData.has_temp_password){
                if(to.name !== 'EResetPassword')
                    next('/e/reset-password');
            }
        }
    }
    }

    // if("layout" in to.meta && to.meta.layout == 'Message'){
    //   return next();
    // }

   
    
    //AuthMiddleware({ to, from, next })
    if("layout" in to.meta && !to.meta.loadMe){
        console.log("ok lay");

        store.state.layout = to.meta.layout;
        return next()
    }
    if (!to.meta.middlewares) {
        store.state.layout = 'blank'
        return next()
    }
    const middlewares = to.meta.middlewares
    Object.keys(middlewares).forEach(middleware => {
        middlewares[middleware]({ to, from, next })
    })
    // return next()
})

export default router


